<template>
  <div>
    <apexchart
		type="line"
		:height="height"
		:width="width"
		:options="chartOptions"
		:series="series"
		:ischart="ischart"
		:categorie="categories"
        :showLables="showLables"
    ></apexchart>
  </div>
</template>

<script>

export default {
	props: {
		options: {
			type: Object
		},
		series: {},
		width: {},
		height: {},
		ischart: {
			type: String
		},
		categories: {
			type: Array
		},
        showLables: {
            type: Boolean
        }
		// series: {
		// 	type:Array
		// }
	},
	computed: {
		chartOptions () {
			return {
				chart: {
					width: 1300,
					height: 250,
					type: 'line'
				},
				plotOptions: {
					bar: {
						borderRadius: 5,
						dataLabels: {
							position: 'top'
						}
					}
				},
                dataLabels: {
					enabled: this.showLables,
					formatter: function (val) {
						return val
					},
					offsetY: 10,
					style: {
						fontSize: '12px',
						colors: ['#0c3b63']
					}
				},
				yaxis: {
					labels: {
						show: true
					}
				},
				xaxis: {
					type: 'months',
					categories: this.categories,
                    tickPlacement: 'between'
				},
				tooltip: {
					enabled: false
				},
				grid: {
					show: true
				},
				theme: {
					mode: this.$vuetify.theme.dark ? 'dark' : 'light'
				},
                
                markers: {
                    size: [4]
                },

                stroke: {
                    curve: 'smooth',
                }
			}
		}
	}
}
</script>
